import React from 'react'
import { observer } from 'mobx-react'
import usePortManager from './hooks/use-port-manager'

function PortIterator (props) {

  const manager = usePortManager()

  return (
    <React.Fragment>
      {manager.ports.map((port) =>
        React.cloneElement(props.children, { key: port.port_id, port: port })
      )}
    </React.Fragment>
  )

}

export default observer(PortIterator)